import { Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import React from 'react';
import config from '../../../config';

export default function TermsAndConditions({ value, setValue }) {
    return (
        <FormControl>
            <FormControlLabel
                control={
                    <Checkbox
                        id="check-term-and-conditions"
                        checked={value}
                        onChange={ev => setValue(ev.target.checked)}
                    />
                }
                label={
                    <span>
                        By checking this box I agree to the{' '}
                        <a
                            href={`${config.assetsUrl}/termsandconditions.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms & Conditions
                        </a>{' '}
                        set forth by Activity Provider which include but are not limited to the
                        sudden change or cancellation of my activity.
                    </span>
                }
            />
        </FormControl>
    );
}
